import styled from 'styled-components';

export const SectionCompaniesTypes = styled.div`
  padding: 50px 0 0;
`;

export const HeaderCompanies = styled.div`
  text-align: center;

  h2 {
    color: inherit !important;

    @media (max-width: 1199.98px) {
      font-size: 26px;
      line-height: 30px;
    }

    @media (max-width: 767.98px) {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 1rem;
    }
  }

  p {
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    color: #898989;

    @media (max-width: 991.98px) {
      color: #898989;
      font-size: 14px;
    }
  }
`;

export const FServices = styled.div``;

export const FBoxList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const FBox = styled.div`
  width: 48%;
  margin: 3rem 0 0;
  padding: 50px 80px;
  background: #f7f7f7;
  border-top: 2px solid #ce445b;
  border-color: #ce445b;

  h3 {
    margin-bottom: 1.5rem;
    line-height: 30px !important;

    @media (max-width: 1199.98px) {
      font-size: 18px;
    }

    @media (max-width: 767.98px) {
      font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
    }
  }

  @media (max-width: 1199.98px) {
    padding: 50px;
  }

  @media (max-width: 991.98px) {
    width: 100%;
  }

  @media (max-width: 575.98px) {
    padding: 30px;
    margin: 2rem 0 0;
  }
`;

export const UlList = styled.ul`
  padding: ${({ dir }) => (dir === 'rtl' ? '0 20px 0 0;' : '0 0 0 20px')};
  margin: 0;
`;

export const LiList = styled.li`
  color: #898989;
  margin-bottom: 1.5rem;

  a {
    color: #000;
    transition: 0.3s;
    &:hover {
      color: #ce445b;
      text-decoration: underline;
    }
  }
`;
